const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:bf7a8961-2070-4c4c-aa7b-48028a8d01da",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_kUpyWc9Ry",
    "aws_user_pools_web_client_id": "1re51e1r8vble3t6l3r8kmb8lo",
    "oauth": {}
};

export default awsmobile;
